/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@/styles/style.css'
import '@/styles/shared/v0010/css/common.css'
import ReactDOM from 'react-dom/client';
import Alert from './js/components/Alert.js';
import React, { createContext } from "react";
import App from './js/App.js';
import IndexProvider from './js/IndexProvider.js';

const root = ReactDOM.createRoot(document.getElementById('rootContainer'));
root.render(<IndexProvider><App /></IndexProvider>);

